import useToggle, { IToggleTrigger } from '@/hooks/useToggle';
import TypeSection from '../TypeSection/TypeSection';
import SortModal from '@/components/SortModal/SortModal';
import { useSearchParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Image } from '@/components/Image';
import PocaSearchModal from '../PocaSearchModal/PocaSearchModal';
import { trackEvent } from '@/components/Event/_lib/eventTrack';
import { SORT_LIST } from '../../_utils/data';

type sortType = 'new' | 'wish';

interface IProps {
  sortModal: IToggleTrigger;
  typeSectionModal: IToggleTrigger;
}
export default function FilterBar({ sortModal, typeSectionModal }: IProps) {
  const [searchParams] = useSearchParams();
  const sortName = searchParams.get('sort') ?? ('new' as sortType);
  const type = searchParams.get('category')?.split(',') ?? ['all'];
  const pocaSearchModal = useToggle({ showing: false });

  return (
    <div className="flex h-full justify-between bg-white">
      <div className="flex gap-[2px] text-[13px] font-medium">
        {/* 검색 */}
        <div
          className="shrink-0 inline-flex items-center justify-center gap-[6px] cursor-pointer border-l border-[#EDEDED] px-5 h-full"
          onClick={() => {
            pocaSearchModal.open();
            trackEvent('PLP_click_POCA_Search');
          }}
        >
          <span className="text-[13px] font-medium">
            <FormattedMessage id="poca_search" defaultMessage="POCA Search" />
          </span>
          <Image src="/icons/search-black.svg" alt="search" width={16} height={16} />
        </div>

        {/* 필터 토글 */}
        {typeSectionModal.isShowing ? (
          <div
            onClick={typeSectionModal.close}
            className="shrink-0 inline-flex items-center justify-center gap-[6px] cursor-pointer border-l border-[#EDEDED] px-5 h-full"
          >
            <FormattedMessage id="close" defaultMessage="Close" />
            <Image src="/icons/close.svg" alt="close" width={16} height={16} />
          </div>
        ) : (
          <div
            onClick={typeSectionModal.open}
            className="shrink-0 inline-flex items-center justify-center gap-[6px] cursor-pointer border-l border-[#EDEDED] px-5 h-full"
          >
            <p>
              <FormattedMessage id="filter" defaultMessage="Filter" />
            </p>
            <Image src="/icons/filter.svg" alt="filter" width={16} height={16} />
          </div>
        )}

        {/* 정렬 */}
        <div
          className="shrink-0 inline-flex items-center justify-center gap-[6px] cursor-pointer border-l border-[#e5e5e5] px-5 h-full"
          onClick={() => {
            sortModal.toggle();
            typeSectionModal.close();
          }}
        >
          <FormattedMessage id={sortName} defaultMessage={SORT_LIST[0].name} />
          <Image src="/icons/sort.svg" alt="sort" width={16} height={16} />
        </div>
      </div>
      {typeSectionModal.isShowing && <TypeSection />}
      {sortModal.isShowing && <SortModal onClose={() => sortModal.close()} />}
      {pocaSearchModal.isShowing && <PocaSearchModal onClose={pocaSearchModal.close} />}
    </div>
  );
}
